import type { ChatState, DeepInsightsState } from "@/types/chat";
import type { ReportState } from "@/types/report";
import type { ModalState } from "@/types/modal";
import type {
  CustomWorkspace,
  CustomWorkspaceState,
} from "@/types/customWorkspace";

export const PARITA_COMMUNITY_DOMAIN = "parity-org-00038.domo.com";

export const initialModalState: ModalState = {
  isOpen: false,
  type: null,
};

export const initialChatState: ChatState = {
  sidebarChats: {
    params: {
      limit: 10,
      query: "",
      offset: 0,
    },
    data: [],
    status: "idle",
    error: null as string | null,
  },
  pendingInitialChats: {},
};

export const initialCustomWorkspaceState: CustomWorkspaceState = {
  sidebarCustomWorkspaces: {
    params: {
      sort: "recent",
      limit: 10,
      query: "",
      offset: 0,
    },
    data: [] as CustomWorkspace[],
    status: "idle",
    error: null as string | null,
  },
  customWorkspaces: {
    params: {
      limit: 10,
      query: "",
      offset: 0,
      sort: "recent",
    },
    data: [] as CustomWorkspace[],
    status: "idle",
    error: null as string | null,
    hasMore: true,
  },
};

export const initialReportState: ReportState = {
  sidebarReports: {
    params: { limit: 10, query: "", offset: 0 },
    data: [],
    status: "idle",
    error: null,
  },
};

export const initialDeepInsightsState: DeepInsightsState = { enabled: false };
